import system from "./system";
import statistics from "./statistics";
import personnel from "./personnel";
import notice from "./notice";
import extension from "./extension";
import develop from "./develop";
import cont from "./cont";
import activity from "./activity";
import mentalTest from "./mentalTest";

/**
 * 华博特项目接口文档
 */
export default {
  system,
  statistics,
  personnel,
  notice,
  extension,
  develop,
  cont,
  activity,
  mentalTest,
};
